import React from "react";
import { Link } from "react-router-dom";
import { PawPrint, Fish, ChevronRight } from "lucide-react";
import Reveal from "./Reveal";

const PageBanner = ({ title, subtitle, crumbs = [] }) => {
  return (
    <section className="relative overflow-hidden rounded-b-[40px] bg-pawelle-bg pt-36 pb-16 md:pt-44 md:pb-20">
      <PawPrint className="pointer-events-none absolute left-10 top-28 h-20 w-20 -rotate-12 text-white opacity-70" />
      <PawPrint className="pointer-events-none absolute left-1/3 bottom-8 h-12 w-12 rotate-12 text-white opacity-60" />
      <Fish className="pointer-events-none absolute right-16 top-28 h-16 w-16 text-white opacity-60" />
      <PawPrint className="pointer-events-none absolute right-10 bottom-10 h-16 w-16 text-white opacity-70" />
      <div className="pointer-events-none absolute right-0 top-0 h-72 w-72 rounded-full bg-[#e9ddf5] opacity-60 blur-2xl" />

      <div className="relative mx-auto max-w-[1290px] px-5 text-center">
        <Reveal animation="fadeInDown">
          <h1 className="font-display text-[40px] font-bold uppercase leading-tight text-pawelle-ink md:text-[64px]">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal animation="fadeInUp" delay={120}>
            <h3 className="mx-auto mt-4 max-w-2xl font-display text-[19px] font-medium text-pawelle-ink/80 md:text-[24px]">
              {subtitle}
            </h3>
          </Reveal>
        )}
        <Reveal animation="fadeInUp" delay={200}>
          <nav className="mt-6 flex items-center justify-center gap-2 font-body text-[15px] font-semibold text-pawelle-body">
            <Link to="/gb/en/home.html" className="transition-colors hover:text-pawelle-primary">Home</Link>
            {crumbs.map((c) => (
              <span key={c} className="flex items-center gap-2">
                <ChevronRight className="h-4 w-4 text-pawelle-primary" />
                <span className="text-pawelle-primary">{c}</span>
              </span>
            ))}
          </nav>
        </Reveal>
      </div>
    </section>
  );
};

export default PageBanner;
